export enum DialogSize {
    SMALL,
    MEDIUM,
    LARGE,
    X_LARGE
}
